const renderMap = () => {
  const MAP_MARKERS = [
    {
      cords: '58.005696, 56.209806',
      name: 'Улица Ленина, 88',
    },
  ];

  const markerIcon = {
    iconLayout: 'default#image',
    iconImageHref: '/catalog/view/theme/default/src/images/icons/map-marker_active.svg',
    iconImageSize: [30, 30],
    iconImageOffset: [-15, -15],
  };

  const map = new ymaps.Map('contacts-map', {
    center: MAP_MARKERS[0].cords.split(','),
    zoom: 14,
    controls: ['zoomControl'],
  }, {
    suppressMapOpenBlock: true,
  });

  MAP_MARKERS.forEach(markerInfo => {
    const markerContent = {
      hintContent: markerInfo.name,
      balloonContent: markerInfo.info
    };
    map.geoObjects.add(new ymaps.Placemark(markerInfo.cords.split(','), markerContent, markerIcon));
  });

  // Делаем карту серой
  try {
    map.panes._array.find((object) => object.key === 'ground').pane._element.style.filter = 'saturate(0)';
  } catch (error) {
    console.error(error);
  }
}

window.onload = () => {
  try {
    ymaps.ready(renderMap);
  } catch (error) {
    console.error(error);
  }
}
